import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_GLOBAL_SEARCH_SCHEMA = Object.freeze({});
const RECORD = generateSchema(TRACKING_GLOBAL_SEARCH_SCHEMA);
const KEYS: any = generateKeys(TRACKING_GLOBAL_SEARCH_SCHEMA);

export class GlobalSearchTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.global_search;
  }

  get properties() {
    return this.toJS();
  }
}
